import Vue from 'vue';
import Main from './main.vue';
const MessageConstructor = Vue.extend(Main);
let instance;

const message = function(options){
  if(typeof options === 'string'){
    options = {
      text: options
    }
  }
  instance = new MessageConstructor({data: options})
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  return instance.vm;
};

['success', 'warning', 'info', 'danger'].forEach(type => {
  message[type] = options => {
    if (typeof options === 'string') {
      options = {
        text: options
      };
    }
    options.type = type;
    return message(options);
  };
});

export default message;


// WEBPACK FOOTER //
// ./src/basic/message/src/message.js